const parseLooseArrayString = (raw) => {
  if (typeof raw !== "string") {
    return [];
  }

  const trimmed = raw.trim();
  if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) {
    return [];
  }

  const attempts = [trimmed];
  if (trimmed.includes("'")) {
    attempts.push(trimmed.replace(/'/g, '"'));
  }

  for (const attempt of attempts) {
    try {
      const parsed = JSON.parse(attempt);
      if (Array.isArray(parsed)) {
        return parsed.map((entry) =>
          typeof entry === "string" ? entry : entry === null || entry === undefined ? "" : String(entry)
        );
      }
    } catch (err) {
      continue;
    }
  }

  const inner = trimmed.slice(1, -1);
  if (!inner.trim()) {
    return [];
  }

  return inner
    .split(",")
    .map((segment) => segment.replace(/['"]/g, "").trim())
    .filter(Boolean);
};

const coerceValueToListEntries = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((entry) => {
        if (typeof entry === "string") {
          return entry;
        }
        if (entry && typeof entry === "object") {
          if (typeof entry.code === "string") {
            return entry.code;
          }
          if (typeof entry.value === "string") {
            return entry.value;
          }
        }
        if (entry === null || entry === undefined) {
          return "";
        }
        return String(entry);
      })
      .filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") {
      return [];
    }
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      return parseLooseArrayString(trimmed);
    }
    if (trimmed.includes(",")) {
      return trimmed
        .split(",")
        .map((segment) => segment.replace(/['"]/g, "").trim())
        .filter(Boolean);
    }
    return [trimmed.replace(/['"]/g, "")];
  }

  if (value && typeof value === "object") {
    if (typeof value.code === "string") {
      return [value.code];
    }
    if (typeof value.value === "string") {
      return [value.value];
    }
    try {
      return [JSON.stringify(value)];
    } catch (err) {
      return [];
    }
  }

  if (value === null || value === undefined) {
    return [];
  }

  return [String(value)];
};

export const normalizeListForComparison = (value) => {
  const entries = coerceValueToListEntries(value);
  if (!entries.length) {
    return "";
  }

  return entries
    .map((entry) => entry.replace(/\s+/g, "").toLowerCase())
    .filter(Boolean)
    .sort()
    .join("|");
};

const coerceToLowerString = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value === "string") {
    return value.trim().toLowerCase();
  }
  if (typeof value === "boolean") {
    return value ? "true" : "false";
  }
  return String(value).trim().toLowerCase();
};

export const interpretNoticeTypeHistoryValue = (value) => {
  const normalized = coerceToLowerString(value);
  if (normalized === "true") {
    return "tender";
  }
  if (normalized === "false" || normalized === "") {
    return "other";
  }
  return null;
};

export const normalizeNoticeTypeFieldValue = (value) => {
  const normalized = coerceToLowerString(value);
  if (normalized === "tender") {
    return "tender";
  }
  if (normalized === "other") {
    return "other";
  }
  return null;
};
